/* GENTCREATE — customer stories viewer.
 *
 * The rail ships as markup and IS the data: every slide's fields live on its
 * button as data-attributes and are read back from the DOM here. The previous
 * version parsed a parallel JSON blob, which meant the markup loop and the JSON
 * loop had to be kept in the same order by hand.
 *
 * The viewer itself is built on the FIRST open and never before: no viewer DOM,
 * no full-size request, no timers on a page where nobody taps a face. */
(function () {
  'use strict';

  var root = document.querySelector('[data-gc-ugc]');
  if (!root) return;

  var buttons = [].slice.call(root.querySelectorAll('[data-gc-ugc-open]'));
  if (!buttons.length) return;

  /* A bubble is one REVIEWER, and a reviewer may have posted more than one
     picture — the rail carries them on data-frames. Expanding them here keeps
     the rail short and honest (one circle per person, so nobody appears to have
     reviewed twice) while leaving every photograph reachable: they become
     consecutive slides sharing that reviewer's name, stars, date and words.
     A bubble with no frames list, or a list of one, behaves exactly as before. */
  var slides = [];
  buttons.forEach(function (b) {
    var d = b.dataset;
    var base = {
      el: b,
      kind: d.kind || 'image',
      src: d.src || '',
      poster: d.poster || '',
      alt: d.alt || '',
      name: d.name || 'Customer',
      rating: parseInt(d.rating || '5', 10),
      date: d.date || '',
      body: d.body || '',
      title: d.title || '',
      country: d.country || '',
      broken: false,
    };
    var frames = null;
    if (d.frames) { try { frames = JSON.parse(d.frames); } catch (e) { frames = null; } }
    if (!frames || frames.length < 2) { slides.push(base); return; }
    frames.forEach(function (f) {
      var s = {};
      for (var k in base) if (Object.prototype.hasOwnProperty.call(base, k)) s[k] = base[k];
      if (f.k) s.kind = f.k;
      if (f.s) s.src = f.s;
      s.poster = f.p || f.s || base.poster;
      if (f.a) s.alt = f.a;
      slides.push(s);
    });
  });

  var T = {};
  var i18nEl = root.querySelector('[data-gc-ugc-i18n]');
  try { T = JSON.parse(i18nEl.textContent) || {}; } catch (e) { T = {}; }
  /* Shopify's t filter returns the literal "Translation missing: ..." rather
     than nil, so it is truthy and | default: never fires. */
  function s(key, fallback) {
    var v = T[key];
    if (!v || String(v).indexOf('Translation missing') === 0) return fallback;
    return v;
  }

  var DURATION = 5000;
  var SEEN_KEY = 'gc-ugc-seen';
  var seen = {};
  try { seen = JSON.parse(localStorage.getItem(SEEN_KEY) || '{}') || {}; } catch (e) {}

  function keyOf(sl) { return sl.kind === 'trustpilot' ? 'tp:' + sl.name + sl.date : sl.src; }
  slides.forEach(function (sl) { if (seen[keyOf(sl)]) sl.el.setAttribute('data-seen', '1'); });
  function markSeen(sl) {
    seen[keyOf(sl)] = 1;
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch (e) {}
    sl.el.setAttribute('data-seen', '1');
  }

  /* ---------- the rail: skeleton off, broken hidden ----------
     Never leave a broken thumbnail in the rail. A story whose file 404s is
     removed from the row AND marked so the viewer steps over it instead of
     landing on an empty frame. */
  slides.forEach(function (sl) {
    var clip = sl.el.querySelector('.gc-ugc__clip');
    if (!clip) return;
    if (clip.classList.contains('gc-ugc__clip--tp')) { clip.classList.add('is-loaded'); return; }
    var img = clip.querySelector('img');
    if (!img) { clip.classList.add('is-loaded'); return; }
    var ok = function () { clip.classList.add('is-loaded'); };
    var bad = function () {
      sl.broken = true;
      var li = sl.el.closest('.gc-ugc__item');
      if (li) li.hidden = true;
    };
    if (img.complete) { img.naturalWidth > 0 ? ok() : bad(); }
    else { img.addEventListener('load', ok, { once: true }); img.addEventListener('error', bad, { once: true }); }
  });

  /* ---------- the viewer ---------- */
  var v = null, bars = [], idx = 0, timer = null, startedAt = 0, remaining = DURATION, paused = false;

  function sized(url, w) {
    if (!url) return url;
    if (url.indexOf('/image/upload/') !== -1 && url.indexOf('/image/upload/w_') === -1) {
      return url.replace('/image/upload/', '/image/upload/w_' + w + ',q_auto,f_auto/');
    }
    if (url.indexOf('cdn.shopify.com') !== -1) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    return url;
  }

  function icon(d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>';
  }
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function q(sel) { return v.querySelector(sel); }

  function build() {
    v = document.createElement('div');
    v.className = 'gc-ugcv';
    v.setAttribute('role', 'dialog');
    v.setAttribute('aria-modal', 'true');
    v.setAttribute('aria-label', s('shareTitle', 'Customer stories'));

    var barsHtml = slides.map(function () { return '<span class="gc-ugcv__bar"><i></i></span>'; }).join('');
    var tpStar = '<svg viewBox="0 0 24 24" focusable="false"><path fill="currentColor" d="M12 2.6l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.7 6.1 20.8l1.2-6.6L2.5 9.6l6.6-.9z"/></svg>';

    v.innerHTML =
      '<div class="gc-ugcv__stage" data-stage>' +
        '<div class="gc-ugcv__bars">' + barsHtml + '</div>' +
        '<div class="gc-ugcv__head">' +
          '<span class="gc-ugcv__avatar"><img alt="" aria-hidden="true"></span>' +
          '<span class="gc-ugcv__who">' +
            '<span class="gc-ugcv__name"></span>' +
            '<span class="gc-ugcv__meta"><span class="gc-ugcv__stars"></span><span class="gc-ugcv__date"></span></span>' +
          '</span>' +
          '<button type="button" class="gc-ugcv__close" aria-label="' + esc(s('close', 'Close')) + '">' +
            icon('<path d="M18 6 6 18M6 6l12 12"/>') +
          '</button>' +
        '</div>' +
        '<div class="gc-ugcv__media" data-media>' +
          '<div class="gc-ugcv__tp" data-tp hidden>' +
            '<div class="gc-ugcv__tpstars" aria-hidden="true">' +
              '<i>' + tpStar + '</i><i>' + tpStar + '</i><i>' + tpStar + '</i><i>' + tpStar + '</i><i>' + tpStar + '</i>' +
            '</div>' +
            '<p class="gc-ugcv__tptitle" data-tp-title></p>' +
            '<p class="gc-ugcv__tpbody" data-tp-body></p>' +
            '<div class="gc-ugcv__tpwho"><span class="gc-ugcv__tpavatar" data-tp-initial></span><span data-tp-who></span></div>' +
          '</div>' +
          '<button type="button" class="gc-ugcv__zone gc-ugcv__zone--prev" aria-label="' + esc(s('prev', 'Previous')) + '"></button>' +
          '<button type="button" class="gc-ugcv__zone gc-ugcv__zone--next" aria-label="' + esc(s('next', 'Next')) + '"></button>' +
        '</div>' +
        '<div class="gc-ugcv__foot">' +
          '<p class="gc-ugcv__caption" data-caption><b data-cap-name></b><span data-cap-body></span>' +
            '<button type="button" class="gc-ugcv__more" data-more hidden aria-expanded="false">' +
              '<span data-more-label>' + esc(s('more', 'More')) + '</span>' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
                'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
                '<path d="M6 9l6 6 6-6"/></svg>' +
            '</button></p>' +
          '<div class="gc-ugcv__actions">' +
            '<button type="button" class="gc-ugcv__act gc-ugcv__act--wide" data-act="comment">' +
              icon('<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.9-.9L3 20.5l1.6-4.6A8.4 8.4 0 0 1 12 3.1a8.4 8.4 0 0 1 9 8.4Z"/>') +
              '<span>' + esc(s('comment', 'Comment')) + '</span>' +
            '</button>' +
            '<button type="button" class="gc-ugcv__act gc-ugcv__act--icon" data-act="share" aria-label="' + esc(s('share', 'Share')) + '">' +
              icon('<path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7"/><path d="M16 6l-4-4-4 4"/><path d="M12 2v13"/>') +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="gc-ugcv__toast"></div>' +
      '</div>';

    document.body.appendChild(v);
    bars = [].slice.call(v.querySelectorAll('.gc-ugcv__bar'));
    wire();
  }

  /* ---------- one slide ---------- */
  function paint(i) {
    var sl = slides[i];
    if (!sl) return;
    var media = q('[data-media]');
    var stage = q('[data-stage]');
    var tp = q('[data-tp]');

    var old = media.querySelector('img:not(.gc-ugcv__lqip), video');
    if (old) old.remove();
    var oldLq = media.querySelector('.gc-ugcv__lqip');
    if (oldLq) oldLq.remove();
    media.classList.remove('is-ready');
    stage.setAttribute('data-kind', sl.kind);

    /* THE THUMBNAIL IS ALREADY IN THE CACHE, SO USE IT.
     *
     * The rail downloaded a 160px version of this very picture to draw the
     * circle the visitor just tapped. Asking for the same URL again is a cache
     * hit, not a request, so it can be painted on the first frame — blurred up
     * to fill the stage — and the thousand-pixel version then cross-fades over
     * it. On a slow connection that is the difference between a black rectangle
     * with a sheen crawling across it and the actual photograph, soft, straight
     * away. It costs nothing on a fast one. */
    if (sl.kind !== 'trustpilot') {
      var lqSrc = sl.poster || sl.src;
      if (lqSrc) {
        var lq = document.createElement('img');
        lq.className = 'gc-ugcv__lqip';
        lq.alt = '';
        lq.setAttribute('aria-hidden', 'true');
        lq.decoding = 'async';
        lq.src = sized(lqSrc, 160);
        media.appendChild(lq);
      }
    }

    if (sl.kind === 'trustpilot') {
      tp.hidden = false;
      q('[data-tp-title]').textContent = '“' + sl.title + '”';
      q('[data-tp-body]').textContent = '“' + sl.body + '”';
      q('[data-tp-initial]').textContent = (sl.name || '?').trim().charAt(0).toUpperCase();
      q('[data-tp-who]').textContent = sl.name + ' — Trustpilot' + (sl.country ? ', ' + sl.country : '');
      media.classList.add('is-ready');
    } else {
      tp.hidden = true;
      var el;
      if (sl.kind === 'video') {
        el = document.createElement('video');
        el.src = sl.src;
        if (sl.poster) el.poster = sized(sl.poster, 800);
        el.autoplay = true; el.muted = true; el.playsInline = true; el.loop = false;
        el.setAttribute('playsinline', '');
        /* a video runs to its own length rather than the 5s image beat */
        el.addEventListener('loadedmetadata', function () {
          if (i !== idx) return;            /* the visitor has already moved on */
          remaining = Math.max(1200, Math.min(20000, (el.duration || 5) * 1000));
          media.classList.add('is-ready');
          if (!paused) run();
        });
        el.addEventListener('ended', function () { if (i === idx) next(); });
        el.addEventListener('error', function () {
          if (i !== idx) return;
          media.classList.add('is-ready');
          next();
        });
      } else {
        el = document.createElement('img');
        el.alt = sl.alt || '';
        el.decoding = 'async';
        /* decode() before revealing — this is what stops the jolt. The skeleton
           holds the frame until the bitmap is ready to paint, then the image
           fades in rather than snapping in mid-decode. */
        el.src = sized(sl.src, 1000);
        /* WHICHEVER OF THESE ARRIVES FIRST REVEALS THE PICTURE.
           decode() is still preferred — it is the only one that promises the
           bitmap is ready to paint, and revealing on 'load' alone can catch the
           browser mid-decode, which is the jolt this was written to remove.
           But decode() is not guaranteed to settle: it resolves off the
           rasteriser, so a tab that is backgrounded, occluded, or otherwise not
           painting leaves it pending indefinitely. It used to be the only path
           that could set is-ready, so whenever it hung the sharp image stayed
           at opacity 0 and the slide sat on its blurred stand-in for good —
           measured here: image loaded, naturalWidth 1000, decode() still
           pending after 45 seconds. 'load' and a three-second ceiling now cover
           it, and the first one to arrive wins.

           The idx guard is what stops a late arrival from marking a slide the
           visitor has already swiped past as ready. go() writes idx before it
           calls paint(), so comparing against the i this call was made with is
           an exact test of "is this still the slide on screen". */
        var revealed = false, revealTimer = 0;
        var reveal = function () {
          if (revealed || i !== idx) return;
          revealed = true;
          clearTimeout(revealTimer);
          media.classList.add('is-ready');
        };
        revealTimer = setTimeout(reveal, 3000);
        if (el.decode) el.decode().then(reveal, reveal);
        el.addEventListener('load', reveal, { once: true });
        el.addEventListener('error', reveal, { once: true });
        if (el.complete) reveal();
      }
      media.insertBefore(el, media.firstChild);

      var nxt = slides[i + 1];
      if (nxt && nxt.kind === 'image') { var pre = new Image(); pre.src = sized(nxt.src, 1000); }
    }

    /* the avatar gets the same treatment — it was the other thing that jolted */
    var av = q('.gc-ugcv__avatar');
    var avImg = av.querySelector('img');
    av.classList.remove('is-loaded');
    if (sl.kind === 'trustpilot') { av.classList.add('is-loaded'); avImg.removeAttribute('src'); }
    else {
      avImg.src = sized(sl.poster || sl.src, 96);
      var avOk = function () { av.classList.add('is-loaded'); };
      if (avImg.decode) avImg.decode().then(avOk, avOk); else avImg.addEventListener('load', avOk, { once: true });
    }

    q('.gc-ugcv__name').textContent = sl.name;
    var r = Math.max(0, Math.min(5, sl.rating || 5));
    q('.gc-ugcv__stars').textContent = '★★★★★'.slice(0, r) + '☆☆☆☆☆'.slice(0, 5 - r);
    var d = sl.date ? new Date(sl.date) : null;
    q('.gc-ugcv__date').textContent = d && !isNaN(d)
      ? d.toLocaleDateString(document.documentElement.lang || undefined, { year: 'numeric', month: 'short' }) : '';

    var cap = q('[data-caption]');
    cap.classList.remove('is-open');
    q('[data-cap-name]').textContent = sl.kind === 'trustpilot' ? '' : sl.name;
    q('[data-cap-body]').textContent = sl.kind === 'trustpilot' ? '' : (sl.body || '');
    var more = q('[data-more]');
    more.hidden = true;
    more.setAttribute('aria-expanded', 'false');
    q('[data-more-label]').textContent = s('more', 'More');
    if (sl.kind !== 'trustpilot' && sl.body) {
      /* Only offer it when the two-line clamp is actually hiding something.
         On a timer rather than an animation frame: rAF does not run in a
         backgrounded tab, and the control would then stay hidden on a caption
         that genuinely is truncated. */
      setTimeout(function () {
        var span = q('[data-cap-body]');
        if (!span) return;
        more.hidden = span.scrollHeight - span.clientHeight <= 2;
      }, 0);
    }

    bars.forEach(function (b, bi) {
      b.classList.toggle('is-done', bi < i);
      var fill = b.querySelector('i');
      fill.style.transition = 'none';
      fill.style.width = bi < i ? '100%' : '0';
    });

    resetZoom();
    markSeen(sl);
  }

  /* ---------- the clock ---------- */
  function run() {
    stop();
    var fill = bars[idx] && bars[idx].querySelector('i');
    if (!fill) return;
    startedAt = Date.now();
    fill.style.transition = 'none';
    fill.style.width = ((DURATION - remaining) / DURATION * 100) + '%';
    void fill.offsetWidth;
    fill.style.transition = 'width ' + remaining + 'ms linear';
    fill.style.width = '100%';
    timer = setTimeout(next, remaining);
  }
  function stop() { if (timer) { clearTimeout(timer); timer = null; } }
  function pause() {
    if (paused) return;
    paused = true; stop();
    remaining = Math.max(300, remaining - (Date.now() - startedAt));
    var fill = bars[idx] && bars[idx].querySelector('i');
    if (fill) { var w = getComputedStyle(fill).width; fill.style.transition = 'none'; fill.style.width = w; }
    var vid = q('video'); if (vid) { try { vid.pause(); } catch (e) {} }
  }
  function resume() {
    if (!paused) return;
    paused = false;
    var vid = q('video'); if (vid) { try { vid.play(); } catch (e) {} }
    run();
  }

  function go(i, dir) {
    dir = dir || 1;
    while (slides[i] && slides[i].broken) i += dir;   /* never land on a 404 */
    if (i < 0) { i = 0; }
    if (i >= slides.length) { close(); return; }
    idx = i;
    remaining = DURATION;
    paused = false;
    paint(idx);
    if (slides[idx].kind !== 'video') run();
  }
  function next() { go(idx + 1, 1); }
  function prev() { go(idx - 1, -1); }

  /* ---------- zoom ---------- */
  var zoom = 1, ox = 0, oy = 0;
  function resetZoom() {
    zoom = 1; ox = 0; oy = 0;
    var m = q('[data-media]'); if (!m) return;
    m.classList.remove('is-zoomed');
    var el = m.querySelector('img:not(.gc-ugcv__lqip), video'); if (el) el.style.transform = '';
  }
  function applyZoom() {
    var m = q('[data-media]');
    var el = m.querySelector('img:not(.gc-ugcv__lqip), video'); if (!el) return;
    m.classList.toggle('is-zoomed', zoom > 1);
    el.style.transform = 'translate(' + ox + 'px,' + oy + 'px) scale(' + zoom + ')';
  }

  function wire() {
    q('.gc-ugcv__close').addEventListener('click', close);
    q('.gc-ugcv__zone--prev').addEventListener('click', function () { hintRetire(); prev(); });
    q('.gc-ugcv__zone--next').addEventListener('click', function () { hintRetire(); next(); });
    v.addEventListener('click', function (e) { if (e.target === v) close(); });

    q('[data-more]').addEventListener('click', function () {
      /* It used to hide itself, so a caption could be opened and never closed.
         It is a disclosure: it toggles, and it says which way it will go. */
      var open = q('[data-caption]').classList.toggle('is-open');
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
      q('[data-more-label]').textContent = open ? s('less', 'Less') : s('more', 'More');
      pause();
    });

    var media = q('[data-media]');
    var downAt = 0, downX = 0, downY = 0, lastTap = 0, pointers = {}, startDist = 0, startZoom = 1, holdTimer = null;

    media.addEventListener('pointerdown', function (e) {
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) { startDist = dist(pointers[ids[0]], pointers[ids[1]]); startZoom = zoom; pause(); return; }
      downAt = Date.now(); downX = e.clientX; downY = e.clientY;
      holdTimer = setTimeout(pause, 220);
    });
    media.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2 && startDist) {
        zoom = Math.max(1, Math.min(4, startZoom * (dist(pointers[ids[0]], pointers[ids[1]]) / startDist)));
        applyZoom();
      } else if (ids.length === 1 && zoom > 1) {
        ox += e.clientX - downX; oy += e.clientY - downY;
        downX = e.clientX; downY = e.clientY;
        applyZoom();
      }
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      media.addEventListener(ev, function (e) {
        delete pointers[e.pointerId];
        if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
        if (Object.keys(pointers).length < 2) startDist = 0;
        var held = Date.now() - downAt;
        var moved = Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY);
        var now = Date.now();
        if (held < 250 && moved < 12) {
          if (now - lastTap < 300) {
            zoom = zoom > 1 ? 1 : 2.4;
            if (zoom === 1) { ox = 0; oy = 0; }
            applyZoom(); lastTap = 0; resume(); return;
          }
          lastTap = now;
        }
        if (zoom <= 1) resume();
      });
    });
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

    var sx = 0;
    media.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    media.addEventListener('touchend', function (e) {
      if (zoom > 1) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 60) { dx < 0 ? next() : prev(); }
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!v || !v.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
      else if (e.key === ' ') { e.preventDefault(); paused ? resume() : pause(); }
    });

    q('[data-act="comment"]').addEventListener('click', function () {
      close();
      if (typeof window.gcOpenChat === 'function' && window.gcOpenChat()) return;
      var tile = document.querySelector('[data-gc-support]');
      if (tile) { tile.click(); return; }
      var fb = tile && tile.getAttribute('data-fallback');
      if (fb) window.location.href = fb;
    });

    q('[data-act="share"]').addEventListener('click', function () {
      var url = s('shareUrl', window.location.href);
      var title = s('shareTitle', document.title);
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      var done = function () { toast(s('copied', 'Link copied')); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
      } else { window.prompt('', url); }
    });
  }

  var toastTimer = null;
  function toast(msg) {
    var t = q('.gc-ugcv__toast'); if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 1800);
  }

  var lastFocus = null;
  function open(i) {
    lastFocus = document.activeElement;
    if (!v) build();
    document.documentElement.classList.add('gc-ugcv-open');
    document.body.classList.add('gc-ugcv-open');
    v.classList.add('is-open');
    go(i, 1);
    q('.gc-ugcv__close').focus();
    if (window.GCOverlayBack) window.GCOverlayBack.opened('gc-ugc-viewer', close);
    showHint();
  }

  /* Shown on the first few opens rather than exactly once. See hintRetire()
     below for the other way out. HINT_KEY is a NEW key on purpose: the old
     'gc-ugcv-hint-seen' latched to '1' on the very first dismissal, timeout
     included, so every browser that had opened the viewer even once was
     already permanently opted out. */
  var HINT_KEY = 'gc-ugcv-hint-n';
  var HINT_MAX = 3;
  function hintSeen() {
    /* a browser that refuses storage gets the hint every time rather than
       never — the failure leans toward being helpful */
    try { return parseInt(localStorage.getItem(HINT_KEY) || '0', 10) || 0; } catch (e) { return 0; }
  }
  function hintWrite(n) { try { localStorage.setItem(HINT_KEY, String(n)); } catch (e) {} }
  /* the visitor has just used the gesture the hint teaches; stop teaching it */
  function hintRetire() { if (hintSeen() < HINT_MAX) hintWrite(HINT_MAX); }
  function showHint() {
    if (hintSeen() >= HINT_MAX) return;
    var stage = q('[data-stage]');
    if (!stage || stage.querySelector('.gc-ugcv__hint')) return;

    var chevron = function (d) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" '
        + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
        + '<path d="' + d + '"/></svg>';
    };
    var el = document.createElement('div');
    el.className = 'gc-ugcv__hint';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<span class="gc-ugcv__hintside gc-ugcv__hintside--l">' + chevron('M15 5l-7 7 7 7') + '</span>'
      + '<span class="gc-ugcv__hintcopy">' + esc(s('tapSides', 'Tap the sides to move through')) + '</span>'
      + '<span class="gc-ugcv__hintside gc-ugcv__hintside--r">' + chevron('M9 5l7 7-7 7') + '</span>';
    stage.appendChild(el);
    hintWrite(hintSeen() + 1);

    var gone = false;
    var dismiss = function () {
      if (gone) return;
      gone = true;
      el.classList.add('is-out');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 420);
    };
    setTimeout(dismiss, 3400);
    stage.addEventListener('pointerdown', dismiss, { once: true });
    v.addEventListener('keydown', dismiss, { once: true });
  }
  function close() {
    stop();
    if (!v) return;
    /* Take the hint overlay down with the viewer. It is only ever removed by
       its own dismiss path — the 3.4s timeout, a pointerdown or a key — so a
       visitor who opened and closed inside those few seconds left the node
       parented to the stage. showHint() then found it still there on the next
       open and returned early, which meant the counter never advanced and the
       hint could be shown far more than the three times it is allowed. The
       showing was already counted when it was built, so this only clears the
       node. */
    var hint = v.querySelector('.gc-ugcv__hint');
    if (hint && hint.parentNode) hint.parentNode.removeChild(hint);
    var vid = q('video'); if (vid) { try { vid.pause(); } catch (e) {} }
    v.classList.remove('is-open');
    document.documentElement.classList.remove('gc-ugcv-open');
    document.body.classList.remove('gc-ugcv-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    /* a no-op when the close came FROM the back gesture — the registry has
       already taken this entry off its stack by then */
    if (window.GCOverlayBack) window.GCOverlayBack.closed('gc-ugc-viewer');
  }

  /* ============================================================ THE RAIL
   * Everything below is about moving the row itself, not about the viewer.
   * A phone already swipes it; a desktop had no way to move it at all, because
   * the scrollbar is hidden and a mouse wheel has no horizontal axis. So: drag
   * with the pointer, and two arrows for people who do not think to try.
   *
   * All of it is gated on a fine pointer. On a touch screen these listeners
   * would fight the browser's own scrolling, which is already better than
   * anything reimplemented here. */
  var rail = root.querySelector('.gc-ugc__rail');
  var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================================================= VIDEOS ON A PHONE
   * A phone has no hover, so the only thing marking a video slide was a small
   * play badge in the corner of a 58px circle — which is easy to miss, and a
   * still frame of a leather case looks exactly like a photograph of one. The
   * clips move now, so it is obvious at a glance which slides are footage.
   *
   * The cost is controlled carefully, because this is the top of a product
   * page on a phone:
   *   - it only ever runs for slides actually on screen, via an observer;
   *   - at most two play at once, so the browser is never decoding six videos;
   *   - it uses the SAME small file the viewer uses, and preload="metadata"
   *     until the moment it is wanted;
   *   - it stops the moment the slide scrolls out, and when the tab is hidden;
   *   - it does not run under prefers-reduced-motion, because unlike the hover
   *     on a desktop nobody asked for this one, or when the visitor has asked
   *     the browser to save data.
   */
  (function () {
    if (fine) return;                                   /* desktop hovers instead */
    if (still) return;
    var conn = navigator.connection || {};
    if (conn.saveData) return;
    if (/2g/.test(conn.effectiveType || '')) return;
    if (!('IntersectionObserver' in window)) return;

    var railEl = root.querySelector('.gc-ugc__rail');
    if (!railEl) return;

    /* three at once. Two left the third frozen on its first frame while its
        neighbours moved, which reads as a video that failed rather than as one
        waiting its turn — and at 58px, muted and looping, a third clip costs
        very little next to that impression. */
    var MAX = 3;
    var live = [];

    function stop(li) {
      var v = li.__gcv;
      if (!v) return;
      /* the canplay listener below fires once, whenever the file is ready —
         which can be after this video has already been stopped. Without this
         flag it would fade a paused video in behind our back. */
      v.__gcstopped = true;
      try { v.pause(); } catch (e) {}
      v.classList.remove('is-on');
      var i = live.indexOf(li);
      if (i !== -1) live.splice(i, 1);
    }

    function start(li) {
      if (live.indexOf(li) !== -1) return;
      while (live.length >= MAX) stop(live[0]);
      var sl = li.__gcslide;
      var clip = li.querySelector('.gc-ugc__clip');
      if (!clip || !sl || !sl.src) return;
      var v = li.__gcv;
      if (!v) {
        v = document.createElement('video');
        v.className = 'gc-ugc__vid';
        v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
        v.setAttribute('aria-hidden', 'true');
        v.tabIndex = -1;
        v.preload = 'metadata';
        v.src = sl.src;
        v.addEventListener('canplay', function () {
          if (v.__gcstopped) return;
          v.classList.add('is-on');
        }, { once: true });
        clip.appendChild(v);
        li.__gcv = v;
      } else {
        v.__gcstopped = false;
        v.classList.add('is-on');
      }
      live.push(li);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio > 0.6) start(e.target);
        else stop(e.target);
      });
    }, { root: railEl, threshold: [0, 0.6, 1] });

    slides.forEach(function (sl) {
      if (sl.kind !== 'video' || !sl.src) return;
      var li = sl.el.closest ? sl.el.closest('.gc-ugc__item') : null;
      if (!li) return;
      li.__gcslide = sl;
      io.observe(li);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) live.slice().forEach(stop);
    });
  })();


  if (rail) {
    var navs = [].slice.call(root.querySelectorAll('[data-gc-ugc-nav]'));

    /* which arrows have somewhere to go. Called on scroll, on resize, and once
       thumbnails have arrived, because a late image changes scrollWidth. */
    function syncNav() {
      var max = rail.scrollWidth - rail.clientWidth;
      var x = rail.scrollLeft;
      navs.forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-gc-ugc-nav'), 10);
        var can = max > 2 && (dir < 0 ? x > 2 : x < max - 2);
        b.classList.toggle('is-on', !!can);
      });
    }
    rail.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    navs.forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = parseInt(b.getAttribute('data-gc-ugc-nav'), 10) || 1;
        /* a bit less than a full screen, so something stays on screen to
           anchor against — a full page turn loses your place */
        var by = Math.max(Math.round(rail.clientWidth * 0.78), 156);
        try { rail.scrollBy({ left: dir * by, behavior: still ? 'auto' : 'smooth' }); }
        catch (err) { rail.scrollLeft += dir * by; }
      });
    });
    syncNav();
    /* one more pass after layout has settled and after the window load, since
       both can change scrollWidth without firing scroll */
    requestAnimationFrame(syncNav);
    window.addEventListener('load', syncNav);

    if (fine) {
      /* ---- drag to scroll ------------------------------------------------ */
      var drag = null;
      var travelled = 0;

      /* CAPTURE ONLY ONCE IT IS REALLY A DRAG.
       *
       * Capturing on pointerdown broke opening a slide altogether. Pointer
       * capture retargets the compatibility mouse events too, so the click that
       * follows a press is delivered against the rail rather than the button
       * under the finger — and the delegated open handler looks for
       * closest('[data-gc-ugc-open]'), which the rail is not. Every tap on a
       * face did nothing.
       *
       * So nothing is captured until the pointer has actually travelled past
       * the threshold. Below it the press is still an ordinary click and the
       * browser routes it normally; past it the rail takes the pointer and the
       * click that eventually arrives is swallowed by the handler below. */
      var THRESHOLD = 6;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (e.button !== 0) return;
        drag = { x: e.clientX, left: rail.scrollLeft, id: e.pointerId, held: false };
        travelled = 0;
      });

      rail.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        if (Math.abs(dx) > travelled) travelled = Math.abs(dx);
        if (!drag.held) {
          if (travelled <= THRESHOLD) return;
          drag.held = true;
          rail.classList.add('is-dragging');
          try { rail.setPointerCapture(e.pointerId); } catch (err) {}
        }
        rail.scrollLeft = drag.left - dx;
        e.preventDefault();
      });

      ['pointerup', 'pointercancel'].forEach(function (ev) {
        rail.addEventListener(ev, function (e) {
          if (!drag || e.pointerId !== drag.id) return;
          if (drag.held) { try { rail.releasePointerCapture(e.pointerId); } catch (err) {} }
          drag = null;
          rail.classList.remove('is-dragging');
          syncNav();
        });
      });

      /* A drag ends with a click on whichever face is under the cursor, which
         would open that slide. Swallowed in the CAPTURE phase on the rail, so
         it never reaches the delegated open handler on root. The threshold is
         what separates a sloppy click from a deliberate drag. */
      rail.addEventListener('click', function (e) {
        if (travelled <= THRESHOLD) return;
        travelled = 0;
        e.preventDefault();
        e.stopPropagation();
      }, true);

      /* ---- hover a video slide and it plays ------------------------------ */
      /* NOT gated on prefers-reduced-motion any more. That setting is about
         motion the page decides to show you; this is motion you asked for by
         putting the pointer on a play badge and holding it there for a beat.
         Gating it meant anyone who had turned animation effects off in Windows
         got a still frame and no indication the slide was a video at all. */
      {
        slides.forEach(function (sl) {
          if (sl.kind !== 'video' || !sl.src) return;
          var clip = sl.el.querySelector('.gc-ugc__clip');
          if (!clip) return;
          var vid = null;
          var wait = null;

          sl.el.addEventListener('pointerenter', function (e) {
            if (e.pointerType && e.pointerType !== 'mouse') return;
            clearTimeout(wait);
            /* a beat before fetching, so sweeping the cursor across the row
               does not start six downloads */
            wait = setTimeout(function () {
              if (vid) {
                vid.classList.add('is-on');
                var p = vid.play(); if (p && p.catch) p.catch(function () {});
                return;
              }
              vid = document.createElement('video');
              vid.className = 'gc-ugc__vid';
              vid.muted = true;
              vid.defaultMuted = true;
              vid.loop = true;
              vid.playsInline = true;
              vid.setAttribute('muted', '');
              vid.setAttribute('playsinline', '');
              vid.setAttribute('aria-hidden', 'true');
              vid.tabIndex = -1;
              vid.preload = 'auto';
              vid.src = sl.src;
              /* it fades in only once there are frames to show, so the poster
                 is never replaced by a black box */
              vid.addEventListener('canplay', function () { vid.classList.add('is-on'); }, { once: true });
              clip.appendChild(vid);
              var p2 = vid.play(); if (p2 && p2.catch) p2.catch(function () {});
            }, 130);
          });

          sl.el.addEventListener('pointerleave', function () {
            clearTimeout(wait);
            if (!vid) return;
            vid.classList.remove('is-on');
            /* kept in the DOM: a second hover is then instant, and it costs one
               paused element per video the visitor actually looked at */
            try { vid.pause(); vid.currentTime = 0; } catch (err) {}
          });
        });
      }
    }
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gc-ugc-open]') : null;
    if (!btn) return;
    open(parseInt(btn.getAttribute('data-gc-ugc-open'), 10) || 0);
  });

  document.addEventListener('visibilitychange', function () {
    if (!v || !v.classList.contains('is-open')) return;
    document.hidden ? pause() : resume();
  });
})();

/* ==========================================================================
   TAPPING THE RATING TAKES YOU TO THE CUSTOMER PHOTOS

   On a handset the star rating at the top of the product page is the first
   piece of social proof a shopper meets, and the thing it should lead to is
   the row of real customer photos further down. This scrolls that row to the
   middle of the screen and then dims and blurs everything around it for a
   moment, so it is obvious what was just been jumped to rather than the page
   simply having moved.

   The dimming is four fixed panels around the row's rectangle rather than one
   overlay with the row raised above it. Raising the row would mean giving it a
   z-index, and it sits inside several blurred panels that each create their
   own stacking context - the same containing-block trap that the model dialog
   has to reparent itself to escape. Four panels need nothing from the page at
   all: the row is never covered, so it never has to be lifted.
   ========================================================================== */
(function () {
  "use strict";

  /* The jump itself lives in gc-reviews-jump.js, which already handled it
     before this was written. Only the ring is defined here, and it is
     published so that one handler can own the whole gesture. */
  function reducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function spotlight(rail, reduce) {
    var r = rail.getBoundingClientRect();
    var pad = 10;
    var t = Math.max(0, r.top - pad);
    var b = Math.min(window.innerHeight, r.bottom + pad);
    var l = Math.max(0, r.left - pad);
    var rt = Math.min(window.innerWidth, r.right + pad);
    var h = Math.max(0, b - t);

    /* Four rectangles left a rectangular hole around a row of circles, which
       is why it read as a box dropped on the page rather than as a light on
       the thing. One dimmed layer with a clip-path hole instead, and the hole
       is a pill - radius half its height - so it follows the circles. The
       corners have to be traced as points because polygon() has no radius. */
    var rad = Math.min(h / 2, (rt - l) / 2);
    var pts = [], SEG = 8;
    (function build() {
      function arc(cx, cy, start) {
        for (var i = 0; i <= SEG; i++) {
          var a = start + (Math.PI / 2) * (i / SEG);
          pts.push(Math.round(cx + Math.cos(a) * rad) + 'px ' + Math.round(cy + Math.sin(a) * rad) + 'px');
        }
      }
      arc(rt - rad, t + rad, -Math.PI / 2);
      arc(rt - rad, b - rad, 0);
      arc(l + rad, b - rad, Math.PI / 2);
      arc(l + rad, t + rad, Math.PI);
    })();
    var poly = 'polygon(evenodd,0px 0px,100% 0px,100% 100%,0px 100%,0px 0px,' + pts.join(',') + ')';

    var wrap = document.createElement("div");
    wrap.className = "gc-ugcspot";
    wrap.setAttribute("aria-hidden", "true");
    var dim = document.createElement("div");
    dim.className = "gc-ugcspot__dim";
    dim.style.clipPath = poly;
    dim.style.webkitClipPath = poly;
    var ring = document.createElement("div");
    ring.className = "gc-ugcspot__ring";
    ring.style.cssText = 'top:' + t + 'px;left:' + l + 'px;width:' + (rt - l) + 'px;height:' + h + 'px;border-radius:' + rad + 'px';
    wrap.appendChild(dim);
    wrap.appendChild(ring);
    document.body.appendChild(wrap);

    /* A fast up-down swiper can scroll straight past the row before the light
       has finished coming up, and then the whole thing has happened off
       screen. Half a second of held scroll is enough to register that the page
       moved somewhere deliberately, and short enough not to feel stuck. */
    /* The scroll lock is gone. Freezing the page for half a second reads as
       the site having hung, not as the site pointing at something - and it
       arrived exactly when a fast scroller was mid-gesture, which is the worst
       possible moment to take the scroll away. The ring does the pointing. */

    /* a timeout rather than requestAnimationFrame: rAF is throttled in a
       background or hidden tab and the class would then be added in the same
       frame as the insert, so the transition would never run */
    setTimeout(function () { wrap.classList.add("is-on"); }, 20);

    setTimeout(function () {
      wrap.classList.remove("is-on");
      setTimeout(function () {
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        busy = false;
      }, reduce ? 0 : 340);
    }, reduce ? 1200 : 1500);
  }

  /* called by gc-reviews-jump.js once its scroll has landed */
  window.gcUgcSpotlight = function () {
    var rail = document.querySelector(".gc-ugc__rail");
    if (rail) spotlight(rail, reducedMotion());
  };
})();
